import { api } from '../core';

export interface DocumentLightBundlePageCountResponse {
  pagesInLightBundle: number;
}

interface DocumentLightBundlePageCountProps {
  abortController?: AbortController;
  documentId: string;
}

const documentLightBundlePageCountApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentLightBundlePageCount: builder.query<
      DocumentLightBundlePageCountResponse,
      DocumentLightBundlePageCountProps
    >({
      query: ({ abortController = new AbortController(), documentId }: DocumentLightBundlePageCountProps) => ({
        url: `document/light-bundle-page-count?document_id=${documentId}`,
        method: 'GET',
        signal: abortController.signal,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getDocumentLightBundlePageCount in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetDocumentLightBundlePageCountQuery } = documentLightBundlePageCountApi;
